import { AchievementRank } from "@/entities/study/models/enums";

export class AchievementRankConverter {
    public convert = (rank: AchievementRank) => {
        const rankMap = {
            [AchievementRank.SPlus]: "S+",
            [AchievementRank.S]: "S",
            [AchievementRank.SMinus]: "S-",
            [AchievementRank.APlus]: "A+",
            [AchievementRank.A]: "A",
            [AchievementRank.AMinus]: "A-",
            [AchievementRank.BPlus]: "B+",
            [AchievementRank.B]: "B",
            [AchievementRank.BMinus]: "B-",
            [AchievementRank.CPlus]: "C+",
            [AchievementRank.C]: "C",
            [AchievementRank.CMinus]: "C-",
            [AchievementRank.F]: "F",
        };

        return rankMap[rank];
    };
}
